import { render } from "./StatusLabel.vue?vue&type=template&id=2006b4b0&scoped=true"
import script from "./StatusLabel.vue?vue&type=script&lang=js"
export * from "./StatusLabel.vue?vue&type=script&lang=js"

import "./StatusLabel.vue?vue&type=style&index=0&id=2006b4b0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2006b4b0"]])

export default __exports__